// src/theme/theme.js
import { createTheme } from '@mui/material/styles';

const FONT = "'Instrument Sans', -apple-system, BlinkMacSystemFont, sans-serif";

const theme = createTheme({
  palette: {
    primary: { main: '#3a3a40', light: '#5a5a61', dark: '#2a2a30', contrastText: '#fff' },
    secondary: { main: '#0066CC' },
    background: { default: '#fff', paper: '#FAFAFA' },
    text: { primary: '#202124', secondary: '#86868b', disabled: '#c7c7cc' },
    divider: '#f0f0f0',
    warning: { main: '#FF9800', light: '#FFF8E1', dark: '#8B6914' },
    error: { main: '#C62828', light: '#FFF0F0' },
    info: { main: '#1565C0', light: '#F0F7FF' },
    success: { main: '#4a7c59' },
    grey: {
      50: '#fafafa', 100: '#f5f5f7', 200: '#f0f0f0', 300: '#e8e8ed',
      400: '#d1d1d6', 500: '#999', 600: '#86868b', 700: '#666', 800: '#444', 900: '#202124',
    },
  },
  typography: {
    fontFamily: FONT,
    h1: { fontSize: 26, fontWeight: 700, letterSpacing: '-0.4px', lineHeight: 1.15 },
    h2: { fontSize: 20, fontWeight: 700, letterSpacing: '-0.3px' },
    h3: { fontSize: 17, fontWeight: 600, letterSpacing: '-0.2px' },
    subtitle1: { fontSize: 15, fontWeight: 600 },
    subtitle2: { fontSize: 14, fontWeight: 500, color: '#86868b' },
    body1: { fontSize: 14, lineHeight: 1.5 },
    body2: { fontSize: 13, lineHeight: 1.4 },
    caption: { fontSize: 12, fontWeight: 700, color: '#bbb', textTransform: 'uppercase', letterSpacing: '0.8px' },
    overline: { fontSize: 11, fontWeight: 600, letterSpacing: '0.5px', textTransform: 'uppercase' },
    button: { fontFamily: FONT, fontWeight: 600, textTransform: 'none' },
  },
  shape: { borderRadius: 6 },
  shadows: [
    'none',
    '0 1px 3px rgba(0,0,0,0.06)',
    '0 2px 8px rgba(0,0,0,0.08)',
    '0 4px 16px rgba(0,0,0,0.1)',
    '0 8px 32px rgba(0,0,0,0.12)',
    '0 16px 48px rgba(0,0,0,0.14)',
    '0 24px 80px rgba(0,0,0,0.15)',
    ...Array(18).fill('none'),
  ],
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 6, padding: '10px 20px', fontSize: 14, boxShadow: 'none', '&:hover': { boxShadow: 'none' } },
        contained: { '&:hover': { boxShadow: 'none' } },
        sizeSmall: { padding: '6px 14px', fontSize: 13 },
        sizeLarge: { padding: '14px 28px', fontSize: 15 },
      },
      defaultProps: { disableElevation: true },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 6, fontWeight: 500, fontFamily: FONT, fontSize: 13.5, height: 34 },
        filled: { '&:hover': { opacity: 0.9 } },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 6, fontFamily: FONT, fontSize: 15,
            '& fieldset': { borderColor: '#e8e8e8', borderWidth: 1.5 },
            '&:hover fieldset': { borderColor: '#ccc' },
            '&.Mui-focused fieldset': { borderColor: '#3a3a40', borderWidth: 1.5 },
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: 6, border: '1px solid #f0f0f0', boxShadow: 'none' },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: { borderRight: '1px solid #f0f0f0', backgroundColor: '#FAFAFA' },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: { borderRadius: 6 },
      },
    },
  },
});

export default theme;
export const SIDEBAR_WIDTH = 260;
export const CONTENT_MAX_WIDTH = 900;
